/**
 * 微信申请审批（weChatApplicationApproval）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/OAoffice/weChatApplicationApproval/ 下 待办/已办列表、
 *          各审批弹窗及 modules 变更/过户/销户组件
 * 术语：微信=WeChat，审批=Approval，申请=Application，通过=Approved，驳回=Rejected，
 *       报停=Suspension，复接=Reconnection，销户=Account Cancellation，过户=Transfer
 */
export default {
  'IMEI号': 'IMEI No.',
  'SIM卡号': 'SIM Card No.',
  '上传': 'Upload',
  '下载': 'Download',
  '不允许': 'Not Allowed',
  '个人新装': 'New Individual Installation',
  '价格信息': 'Price Info',
  '价格信息变更': 'Price Info Change',
  '价格信息变更信息': 'Price Info Change Details',
  '价格名称': 'Price Name',
  '企业': 'Enterprise',
  '企业变更信息': 'Enterprise Change Information',
  '企业名称': 'Enterprise Name',
  '企业地址': 'Enterprise Address',
  '企业基本信息': 'Enterprise Basic Information',
  '企业新装': 'New Enterprise Installation',
  '企业电话': 'Enterprise Phone',
  '企业编号': 'Enterprise ID',
  '优惠信息': 'Discount Info',
  '允许': 'Allowed',
  '公司营业执照': 'Business License',
  '关联工单': 'Related Work Order',
  '关闭': 'Close',
  '其他信息': 'Other Information',
  '变更方式': 'Change Method',
  '变更用水性质': 'Change Water Use Category',
  '启用日期': 'Effective Date',
  '基本信息': 'Basic Information',
  '处理': 'Handle',
  '处理中': 'Processing',
  '处理人': 'Handler',
  '处理时间': 'Handling Time',
  '复接': 'Reconnection',
  '委托书': 'Letter of Authorization',
  '审批': 'Approval',
  '审批中': 'Under Approval',
  '审批人': 'Approver',
  '审批历史': 'Approval History',
  '审批处理': 'Approval Handling',
  '审批已驳回，工单存放在已办。': 'Approval rejected. The work order is stored in Done.',
  '审批意见': 'Approval Opinion',
  '审批描述': 'Approval Description',
  '审批时间': 'Approval Time',
  '审批状态': 'Approval Status',
  '审批通过': 'Approved',
  '审核工单': 'Work Order Review',
  '小区或村庄名': 'Community or Village Name',
  '工单状态': 'Work Order Status',
  '工单类型': 'Work Order Type',
  '工单紧急程度': 'Work Order Urgency',
  '工单编号': 'Work Order No.',
  '已办': 'Done',
  '已开始计费': 'Billing Started',
  '已撤销': 'Revoked',
  '已结束': 'Finished',
  '已驳回': 'Rejected',
  '已驳回，等待用户重新提交后审批': 'Rejected. Waiting for the user to resubmit for approval',
  '归档': 'Archive',
  '待办': 'To Do',
  '房产证': 'Property Certificate',
  '房产证/营业执照': 'Property Certificate / Business License',
  '手机号': 'Mobile Phone',
  '手机号码': 'Mobile Phone',
  '扣完再启用新价格': 'Enable New Price After Deduction',
  '报停': 'Suspension',
  '报停恢复': 'Service Resumption',
  '按人': 'Per Person',
  '按户': 'Per Household',
  '按月': 'Monthly',
  '按量': 'By Volume',
  '换表': 'Meter Replacement',
  '接单': 'Accept',
  '提交': 'Submit',
  '撤销': 'Revoke',
  '操作': 'Action',
  '操作人': 'Operated By',
  '操作时间': 'Operation Time',
  '故障报修': 'Fault Repair',
  '新企业名称': 'New Enterprise Name',
  '新企业地址': 'New Enterprise Address',
  '新企业电话': 'New Enterprise Phone',
  '新增': 'Add',
  '新用户信息': 'New Customer Info',
  '新用户地址': 'New Customer Address',
  '新用户姓名': 'New Customer Name',
  '新用户电话': 'New Customer Phone',
  '新身份证号': 'New ID Number',
  '无图片': 'No Image',
  '无文件': 'No File',
  '旧用户信息': 'Original Customer Info',
  '是否允许缴费': 'Payment Allowed',
  '是否本人': 'Is the Applicant Himself/Herself',
  '未开始计费': 'Billing Not Started',
  '本人': 'Himself/Herself',
  '查看反馈': 'View Feedback',
  '查询': 'Query',
  '水变审': 'Water Category Change Approval',
  '水变详情': 'Water Category Change Details',
  '法人姓名': 'Legal Representative Name',
  '法人电话': 'Legal Representative Phone',
  '法人身份证号': 'Legal Representative ID No.',
  '法人身份证正反面': 'Legal Representative ID Card (Front & Back)',
  '用变审': 'User Info Change Approval',
  '用变详情': 'User Info Change Details',
  '用户信息变更': 'Customer Info Change',
  '用户信息变更信息': 'User Info Change Details',
  '用户信息变更审批': 'User Info Change Approval',
  '用户信息变更详情': 'User Info Change Details',
  '用户反馈': 'User Feedback',
  '用户变更信息': 'User Change Information',
  '用户地址': 'Customer Address',
  '用户基本信息': 'Customer Basic Information',
  '用户姓名': 'Customer Name',
  '用户电话': 'Customer Phone',
  '用户类型': 'Customer Type',
  '用户编号': 'Customer No.',
  '用户过户': 'Customer Ownership Transfer',
  '用户过户信息': 'Customer Transfer Information',
  '用水': 'Water Use',
  '用水性质变更': 'Water Use Category Change',
  '用水性质变更审批': 'Water Use Category Change Approval',
  '用水性质变更详情': 'Water Use Category Change Details',
  '用水状态': 'Water Use Status',
  '用水类型': 'Water Use Type',
  '申请原因': 'Application Reason',
  '申请时间': 'Application Time',
  '申请类型': 'Application Type',
  '电子签名': 'E-Signature',
  '确定': 'OK',
  '确定接单吗?': 'Are you sure to accept the order?',
  '立即结算': 'Settle Immediately',
  '签名': 'Signature',
  '编辑': 'Edit',
  '自然人': 'Natural Person',
  '草稿': 'Draft',
  '营收编号': 'Revenue No.',
  '表具信息': 'Meter Info',
  '表安装地址': 'Meter Installation Address',
  '表类型': 'Meter Type',
  '表编号': 'Meter No.',
  '被委托人姓名': 'Entrusted Person Name',
  '被委托人电话': 'Entrusted Person Phone',
  '被委托人身份证（正反面）': 'Entrusted Person ID Card (Front & Back)',
  '计费起始读数': 'Billing Start Reading',
  '评价': 'Evaluation',
  '详情': 'Details',
  '请输入停水原因': 'Please enter water outage cause',
  '请输入停水范围': 'Please enter water outage range',
  '请输入审批描述': 'Please enter approval description',
  '请输入工单编号': 'Please enter work order no.',
  '请输入用户反馈': 'Please enter user feedback',
  '请输入用户姓名查询': 'Enter customer name to search',
  '请输入用户电话查询': 'Enter user phone to search',
  '请输入用户编号查询': 'Enter customer No. to search',
  '请选择停水开始时间': 'Please select the water outage start time',
  '请选择停水结束时间': 'Please select the water outage end time',
  '请选择审批意见': 'Please select approval opinion',
  '请选择工单类型': 'Please select work order type',
  '请选择工单紧急程度': 'Please select work order urgency',
  '请选择申请类型': 'Please select application type',
  '身份类型': 'Identity Type',
  '身份证号': 'ID Number',
  '身份证正反面': 'ID Card (Front & Back)',
  '过户': 'Transfer',
  '过户审批': 'Transfer Approval',
  '过户详情': 'Transfer Details',
  '通过': 'Approve',
  '重置': 'Reset',
  '销户': 'Account Cancellation',
  '销户审批': 'Account Cancellation Approval',
  '销户详情': 'Account Cancellation Details',
  '非本人': 'Not Himself/Herself',
  '预览': 'Preview',
  '驳回': 'Reject',
};
